export default __webpack_public_path__ + "aa7cb0887543a4649aadf04bd6104117.png";